function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './DAcApplication.css';
import React, { useEffect, useState, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ProgressApplication from './components/ProgressApplication';
import StepsProvider from './components/StepsProvider';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { get, getDictionaryItem } from '../../utils';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import { GetAllLookups, GetDetails } from './components/actions';
import { forEach, find } from 'lodash';
import Cookies from 'js-cookie';
import { parsePhoneNumber } from 'react-phone-number-input';
export let EStatus = /*#__PURE__*/function (EStatus) {
  EStatus["Inactive"] = "INACTIVE";
  EStatus["Active"] = "ACTIVE";
  EStatus["Completed"] = "COMPLETED";
  return EStatus;
}({});
const Application = props => {
  const {
    fields,
    params
  } = props;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const {
    data: {
      configuration,
      dictionaryApplicantDetails,
      dictionaryNavigation,
      dictionaryPassportDetails,
      dictionaryPaymentSubmitApplication,
      dictionaryUploadDocument,
      settings,
      countries
    }
  } = fields;
  const apiKey = get(settings, 'apiKey.jss.value') || '';
  const apiUrl = get(settings, 'apiUrl.jss.value') || '';
  const serviceId = get(settings, 'serviceId.jss.value') || null;
  const loginPage = get(settings, 'loginPage.jss.value.href') || '';
  const availableNationalities = get(settings, 'availableNationalities.targetItems') || [];
  const countriesList = get(countries, 'countryValues') || [];
  const sessionId = Math.random().toString(16).slice(2);
  const dashboardUrl = get(configuration, 'buttonBackUrl.jss.value.href') || '/';
  const initialSteps = [{
    id: 0,
    title: get(configuration, 'pdNavigationTitle.jss.value') || '',
    status: EStatus.Active,
    dictionary: dictionaryPassportDetails,
    dictionaryNavigation,
    validateMessage: getDictionaryItem(dictionaryPassportDetails, 'validateError'),
    data: _objectSpread({
      availableNationalities,
      title: {
        value: get(configuration, 'pdTitle.jss.value') || ''
      },
      shortDescription: get(configuration, 'pdShortDescription.jss.value') || ''
    }, configuration)
  }, {
    id: 1,
    title: get(configuration, 'adNavigationTitle.jss.value') || '',
    status: EStatus.Inactive,
    dictionary: dictionaryApplicantDetails,
    dictionaryNavigation,
    validateMessage: getDictionaryItem(dictionaryPassportDetails, 'validateError'),
    data: _objectSpread({
      title: {
        value: get(configuration, 'adTitle.jss.value') || ''
      },
      countriesList,
      shortDescription: get(configuration, 'adShortDescription.jss.value') || ''
    }, configuration)
  }, {
    id: 2,
    title: get(configuration, 'udNavigationTitle.jss.value') || '',
    status: EStatus.Inactive,
    dictionary: dictionaryUploadDocument,
    dictionaryNavigation: dictionaryNavigation,
    validateMessage: getDictionaryItem(dictionaryPassportDetails, 'validateError'),
    data: _objectSpread({
      title: {
        value: get(configuration, 'udTitle.jss.value') || ''
      },
      shortDescription: get(configuration, 'udShortDescription.jss.value') || ''
    }, configuration)
  }, {
    id: 3,
    title: get(configuration, 'pSaNavigationTitle.jss.value') || '',
    status: EStatus.Inactive,
    dictionary: dictionaryPaymentSubmitApplication,
    dictionaryNavigation,
    validateMessage: getDictionaryItem(dictionaryPassportDetails, 'validateError'),
    data: _objectSpread({
      title: {
        value: get(configuration, 'pSaTitle.jss.value') || ''
      },
      dashboardUrl,
      shortDescription: get(configuration, 'pSaShortDescription.jss.value') || ''
    }, configuration)
  }];
  const history = useHistory();
  const {
    search
  } = useLocation();
  const searchParams = new URLSearchParams(search);
  const appn = searchParams.get('appn');
  const stepId = searchParams.get('step');
  const componentRef = useRef(null);
  const [applicationNumber, setApplicationNumber] = useState('');
  const [steps, setSteps] = useState(initialSteps);
  const [context, setContext] = useState({});
  const [documents, setDocuments] = useState([]);
  const [lookups, setLookups] = useState([]);
  const [isLoadingWizard, seIsLoadingWizard] = useState(false);
  const [userTokken, setUserTokken] = useState('');
  const [username, setUsername] = useState('');
  const [isTranslateAvaible, setIsTranslateAvaible] = useState(true);
  const currentStep = steps.slice().reverse().find(_ref => {
    let {
      status
    } = _ref;
    return status === EStatus.Active;
  });
  const currentStepId = currentStep && currentStep.id || 0;
  const clickStep = id => {
    setSteps(steps.map((step, index) => {
      if (id === step.id) {
        step.status = EStatus.Active;
      } else if (step.status === EStatus.Active && id < index) step.status = EStatus.Inactive;else if (step.status === EStatus.Active) step.status = EStatus.Completed;
      return step;
    }));
  };
  const clickBackButton = e => {
    e.preventDefault();
    if (currentStepId === 0) {
      history.push(dashboardUrl);
      return;
    }
    clickStep(currentStepId - 1);
  };
  const getLookupOptions = name => {
    const lookup = find(lookups, props => {
      const lookupName = Object.keys(props);
      if (lookupName && lookupName[0] === name) return props;
    });
    return lookup && lookup[name] || [];
  };
  useEffect(() => {
    async function fetchSelectOption() {
      seIsLoadingWizard(true);
      const response = await GetAllLookups({
        apiKey,
        apiUrl,
        sessionId,
        userTokken
      });
      setLookups(response);
      seIsLoadingWizard(false);
    }
    const tokken = Cookies.get('token');
    const userNameCookie = Cookies.get('username');
    if (userNameCookie) setUsername(userNameCookie);
    if (!tokken) {
      history.push(loginPage);
    } else {
      setUserTokken(tokken);
    }
    fetchSelectOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    async function fetchApp() {
      if (!appn) return;
      seIsLoadingWizard(true);
      setApplicationNumber(appn);
      const newContext = await GetDetails({
        apiKey,
        apiUrl,
        sessionId,
        userTokken
      }, appn);
      forEach(newContext, (value, name) => {
        if (name === 'addressOutsideTelNo') {
          let collectValue = value;
          let code = '';
          const parsedmobileNo = parsePhoneNumber(`+${value}`);
          if (parsedmobileNo) {
            collectValue = parsedmobileNo.nationalNumber;
            code = parsedmobileNo.countryCallingCode;
          }
          updateContext({
            [name]: _objectSpread(_objectSpread({}, context[name]), {}, {
              value: collectValue,
              code,
              valid: true
            })
          });
        } else {
          updateContext({
            [name]: _objectSpread(_objectSpread({}, context[name]), {}, {
              value,
              valid: true
            })
          });
        }
      });
      seIsLoadingWizard(false);
    }
    if (lookups.length) fetchApp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookups]);
  useEffect(() => {
    if (stepId) {
      const currentStepId = parseInt(stepId) - 1;
      clickStep(currentStepId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepId]);
  useEffect(() => {
    if (applicationNumber.length) Cookies.set('applicationNumber', applicationNumber);
  }, [applicationNumber]);
  const updateContext = data => {
    setContext(state => _objectSpread(_objectSpread({}, state), data));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "wizard",
    ref: componentRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group  module-group--inside d-block  d-sm-none"
  }, /*#__PURE__*/React.createElement("a", {
    href: "##",
    className: "link back-button",
    onClick: clickBackButton
  }, /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "btn-link__icon btn-link-icon"
  }), ' ', getDictionaryItem(dictionaryNavigation, 'NavigationBack'))), /*#__PURE__*/React.createElement("div", {
    className: "wizard__header"
  }, /*#__PURE__*/React.createElement(ProgressApplication, {
    rtl: rtl,
    steps: steps,
    className: "module-group module-group--inside"
  })), /*#__PURE__*/React.createElement(StepsProvider, {
    rtl: rtl,
    context: context,
    appRef: componentRef,
    currentStepId: currentStepId,
    updateSteps: clickStep,
    steps: steps,
    updateContext: updateContext,
    getLookupOptions: getLookupOptions,
    lookups: lookups,
    applicationNumber: applicationNumber,
    appn: appn,
    setApplicationNumber: setApplicationNumber,
    documents: documents,
    setDocuments: setDocuments,
    apiConfig: {
      apiKey,
      apiUrl,
      serviceId,
      sessionId,
      userTokken,
      redirectUrl: loginPage,
      history,
      dashboardUrl,
      username
    },
    isLoadingWizard: isLoadingWizard,
    isTranslateAvaible: isTranslateAvaible,
    setIsTranslateAvaible: setIsTranslateAvaible
  })));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: ` ${fullWidthStyles} ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export default Application;
const commonStyles = "ctk59l5";
const fullWidthStyles = "f1yxvp0";
const rtlStyles = "rq4h6cz";
const ltrStyles = "l1msews6";